<template>
  <div>
    <div class="heart is-active" @click="onLike"></div>
  </div>
</template>

<script>
  export default {
    name: "LikeComponent",
    methods: {
      onLike() {

      }
    }
  }
</script>

<style lang="scss" scoped>
  .heart {
    width: 100px;
    height: 100px;
    background: url("https://cssanimation.rocks/images/posts/steps/heart.png") no-repeat;
    background-position: 0 0;
    cursor: pointer;
    transition: background-position 1s steps(28);
    transition-duration: 0s;
  }
  .is-active {
    transition-duration: 1s;
    background-position: -2800px 0;
  }
</style>
